import request from '@/utils/request'

export const launchDelivery = (orderId: string) =>
  request({
    url: `/market/v1/orders/${orderId}/deliver`,
    method: 'put'
  })
